module.exports = __webpack_public_path__ + "img/P25.8e4be026.png";